import {t} from 'i18next';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {parse} from 'json2csv/dist/json2csv.umd';
import {QuestionReport} from '../../../../incase-domain/analytics';
import {IQuestionAnswerType} from '../../../../incase-domain/elements/base/questionElementBase';

const ALL_CORRECT = 'All correct';

const ANSWER_TYPE_LABEL_KEYS = {
    correct: 'designSidepanel.correct',
    incorrect: 'designSidepanel.incorrect',
    debatable: 'designSidepanel.debatable',
} as const;

const CSV_FIELDS = [
    {value: 'slide', labelKey: 'reportPage.questionCsv.slide'},
    {value: 'question', labelKey: 'reportPage.questionCsv.question'},
    {value: 'answer', labelKey: 'reportPage.questionCsv.answer'},
    {value: 'answerType', labelKey: 'reportPage.questionCsv.answerType'},
    {value: 'responses', labelKey: 'reportPage.questionCsv.responses'},
    {value: 'percentage', labelKey: 'reportPage.questionCsv.percentage'},
    {value: 'totalResponses', labelKey: 'reportPage.questionCsv.totalResponses'},
] as const;

type CsvRow = Record<(typeof CSV_FIELDS)[number]['value'], string | number>;

const formatPercentage = (percentage: number | undefined): string => (percentage === undefined ? '' : `${percentage}%`);
const getPercentage = (count: number, total: number): number => (total ? Math.round((count * 100) / total) : 0);

function getAnswerTypeLabel(type: IQuestionAnswerType | undefined, isDebatableQuestion: boolean | undefined): string {
    const answerType = isDebatableQuestion && type ? 'debatable' : type;
    return answerType ? t(ANSWER_TYPE_LABEL_KEYS[answerType]) : '';
}

function toCsvRows(report: QuestionReport): CsvRow[] {
    const questionColumns = {slide: report.slide.name, question: report.question, totalResponses: report.totalAnswers};
    const answers = report.answers ?? [];

    if (report.likertScaleData?.length) {
        return report.likertScaleData.flatMap((statement) =>
            answers.map((scale) => {
                const count = Number(statement[scale.answerText] ?? 0);
                return {
                    ...questionColumns,
                    question: `${report.question}: ${statement.questionText}`,
                    answer: scale.answerText,
                    answerType: '',
                    responses: count,
                    percentage: formatPercentage(getPercentage(count, report.totalAnswers)),
                };
            })
        );
    }

    return answers.map((answer) => ({
        ...questionColumns,
        answer: answer.answerText === ALL_CORRECT ? t('reportPage.questionCsv.allCorrect') : answer.answerText,
        answerType: getAnswerTypeLabel(answer.type, report.isDebatable),
        responses: answer.noOfAnswers ?? '',
        percentage: formatPercentage(answer.percentage),
    }));
}

export function getQuestionReportCsv(reports: QuestionReport[]): string {
    return parse(reports.flatMap(toCsvRows), {fields: CSV_FIELDS.map(({value, labelKey}) => ({value, label: t(labelKey)}))});
}
